import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
} from "react-icons/si";

// Import Kali logo (store it locally or use a URL)
const kaliLogo = "https://upload.wikimedia.org/wikipedia/commons/2/2b/Kali-dragon-icon.svg";
const ubuntuLogo = "https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo-ubuntu_cof-orange-hex.svg";
//const windowsLogo = "https://upload.wikimedia.org/wikipedia/commons/5/5f/Windows_logo_-_2021.svg";


function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={kaliLogo} alt="Kali Linux" style={{ width: "50px", height: "50px" }} />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={ubuntuLogo} alt="Ubuntu" style={{ width: "50px", height: "50px" }} />
      </Col>
    </Row>
  );
}

export default Toolstack;
